import Icon from "@ant-design/icons";
import dayjs from "dayjs";
import { DatePicker, Typography } from "antd";
import { NumericFormat } from "react-number-format";

export const ReportingPeriodOptions = [
  {
    value: "2023",
    label: "2023",
    children: [
      {
        value: "Q1",
        label: "Q1",
      },
      {
        value: "Q2",
        label: "Q2",
      },
      {
        value: "Q3",
        label: "Q3",
      },
      {
        value: "Q4",
        label: "Q4",
      },
    ],
  },
  {
    value: "2022",
    label: "2022",
    children: [
      {
        value: "Q1",
        label: "Q1",
      },
      {
        value: "Q2",
        label: "Q2",
      },
      {
        value: "Q3",
        label: "Q3",
      },
      {
        value: "Q4",
        label: "Q4",
      },
    ],
  },
  {
    value: "2021",
    label: "2021",
    children: [
      {
        value: "Q1",
        label: "Q1",
      },
      {
        value: "Q2",
        label: "Q2",
      },
      {
        value: "Q3",
        label: "Q3",
      },
      {
        value: "Q4",
        label: "Q4",
      },
    ],
  },
  {
    value: "2020",
    label: "2020",
    children: [
      {
        value: "Q1",
        label: "Q1",
      },
      {
        value: "Q2",
        label: "Q2",
      },
      {
        value: "Q3",
        label: "Q3",
      },
      {
        value: "Q4",
        label: "Q4",
      },
    ],
  },
];

export const periodOptions = [
  {
    value: "Q1",
    label: "Q1",
  },
  {
    value: "Q2",
    label: "Q2",
  },
  {
    value: "Q3",
    label: "Q3",
  },
  {
    value: "Q4",
    label: "Q4",
  },
];
export const QuarterOptions = [
  {
    value: "Q1",
    name: "Q1",
  },
  {
    value: "Q2",
    name: "Q2",
  },
  {
    value: "Q3",
    name: "Q3",
  },
  {
    value: "Q4",
    name: "Q4",
  },
];

export const statusOptions = [
  {
    name: "To Do",
    color: "#D9534F",
  },
  {
    name: "In Progress",
    color: "#F0AD4E",
  },
  {
    name: "Done",
    color: "#5CB85C",
  },
  {
    name: "Blocked",
    color: "#5BC0DE",
  },
  {
    name: "Review",
    color: "#337AB7",
  },
  // Add more status options as needed
];

export const MonthOptions = [
  {
    abbreviation: "Jan",
    value: 1,
    name: "January",
  },
  {
    abbreviation: "Feb",
    value: 2,
    name: "February",
  },
  {
    abbreviation: "Mar",
    value: 3,
    name: "March",
  },
  {
    abbreviation: "Apr",
    value: 4,
    name: "April",
  },
  {
    abbreviation: "May",
    value: 5,
    name: "May",
  },
  {
    abbreviation: "Jun",
    value: 6,
    name: "June",
  },
  {
    abbreviation: "Jul",
    value: 7,
    name: "July",
  },
  {
    abbreviation: "Aug",
    value: 8,
    name: "August",
  },
  {
    abbreviation: "Sep",
    value: 9,
    name: "September",
  },
  {
    abbreviation: "Oct",
    value: 10,
    name: "October",
  },
  {
    abbreviation: "Nov",
    value: 11,
    name: "November",
  },
  {
    abbreviation: "Dec",
    value: 12,
    name: "December",
  },
];

export const StatusList = [
  { value: "to_do", label: "To Do" },
  { value: "in_progress", label: "In Progress" },
  { value: "done", label: "Done" },
  { value: "testing", label: "Testing" },
  { value: "review", label: "Review" },
  { value: "archive", label: "Archive" },
];

export const getScopeColor = (scope) => {
  if (scope === 1) {
    return "#E99762";
  } else if (scope === 2) {
    return "#90CDB7";
  } else if (scope === 3) {
    return "#2B4D85";
  }
};

export const CustomIcon = ({ svg }) => (
  <Icon component={svg} style={{ fontSize: "21px" }} />
);

export const CustomNumberWithUnit = ({ emission, unit, ...rest }) => {
  return (
    <Typography.Text {...rest}>
      {emission ? (
        <>
          <NumericFormat
            value={emission}
            displayType={"text"}
            thousandsGroupStyle="lakh"
            thousandSeparator=","
            decimalScale={1}
            fixedDecimalScale={true}
          />{" "}
          {unit}
        </>
      ) : (
        "-"
      )}
    </Typography.Text>
  );
};

export const CustomNumber = ({ number, divider }) => {
  return (
    <NumericFormat
      value={+number / (+divider ? +divider : 1)}
      displayType={"text"}
      thousandsGroupStyle="lakh"
      thousandSeparator=","
      decimalScale={1}
      fixedDecimalScale={true}
    />
  );
};

export const CustomDatePicker = ({
  defaultValue,
  handleYearChange,
  ...rest
}) => {
  return (
    <DatePicker
      size="large"
      {...rest}
      onChange={handleYearChange}
      style={{
        borderTop: "none",
        borderLeft: "none",
        borderRight: "none",
        borderRadius: 0,
        boxShadow: "none",
        background: "none",
      }}
      picker="year"
      defaultValue={dayjs().year(defaultValue)}
      disabledDate={(current) => {
        return dayjs(current).isAfter(dayjs(), "year");
      }}
    />
  );
};

export const getTreeDataDropDown = (node) => {
  const mappedNode = {
    value: node?.id,
    title: node?.name,
  };

  if (node?.children && node?.children?.length > 0) {
    mappedNode.children = node?.children?.map((child) =>
      getTreeDataDropDown(child)
    );
    // mappedNode.disabled = true;
  }

  return mappedNode;
};

// export const GetInputField = ({ type, ...rest }) => {
//   return (
//     (type === "decimal" && <InputNumber {...rest} />) ||
//     (type === "integer" && <InputNumber {...rest} />) ||
//     (type === "single_ln_text" && <Input {...rest} />) ||
//     (type === "multi_ln_text" && (
//       <Input.TextArea
//         autoSize={{
//           minRows: 3,
//           maxRows: 6,
//         }}
//         {...rest}
//       />
//     )) ||
//     (type === "date" && <DatePicker {...rest} picker="date" />) ||
//     (type === "year" && <DatePicker {...rest} picker="year" />)
//   );
// };

export const getFinancialYearRange = (startMonth, endMonth) => {
  const currentMonth = dayjs().month();
  const currentYear = dayjs().year();

  let startYear = currentYear;
  let endYear = currentYear + 1;

  if (currentMonth < startMonth) {
    startYear = currentYear - 1;
    endYear = currentYear;
  }

  const startDate = dayjs().year(startYear).month(startMonth).startOf("month");
  const endDate = dayjs().year(endYear).month(endMonth).endOf("month");

  return [startDate, endDate];
};
